module.exports = __webpack_public_path__ + "img/icon-info-white.1aba3567.svg";